import { useCallback, useEffect, useState } from "react";
import {
  get_grading_Services,
  edit_grading_service_tatus,
  delete_grading_Services,
} from "../../../reduxData/user/userAction";

const useGrading = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const getServices = useCallback(async () => {
    setLoading(true);
    const res = await get_grading_Services();
    setServices(res?.data || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    getServices();
  }, [getServices]);

  const handleDeletePopup = useCallback((id) => {
    setDeleteId(id);
    setOpen(true);
  }, []);

  const handleDeleteService = useCallback(async () => {
    const res = await delete_grading_Services(deleteId);
    if (res) {
      setOpen(false);
      getServices();
    }
  }, [deleteId]);

  const handleToggleStatus = useCallback(async (item) => {
    const id = item?.id || item?._id;
    const newStatus = !item?.is_active;
    const res = await edit_grading_service_tatus(id, { is_active: newStatus });
    if (res) getServices();
  }, []);

  return {
    services,
    loading,
    open,

    setOpen,
    getServices,
    handleToggleStatus,
    handleDeleteService,
    handleDeletePopup,
  };
};

export default useGrading;
